
































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DetailPageLayout extends Vue {
  dataType = "CN";

  @Prop({ type: String, default: "" })
  treeTitle!: string;

  @Prop({ type: String, default: "" })
  bodyTitle!: string;

  onRadioChange(value: string) {
    this.$emit("country-change", value);
  }
};
